import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

interface PaymentModeApiResponse {
    pay_code: string;
    pay_typedesc?: string | null;
    pay_iscredit?: boolean | null;
    pay_iscash?: boolean | null;
    pay_accno?: string | null;
}

export interface PaymentModeResponse {
    paycode: string;
    paytypedesc?: string | null;
    payIsCredit?: boolean;
    payIsCash?: boolean;
    payAccNo?: string | null;
}

export const getAllPaymentModes = async (): Promise<PaymentModeResponse[]> => {
    try {
        const response: ApiResponse<PaymentModeApiResponse[] | null> = (
            await apiClient.get("/pos_paymode/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return (response.data || []).map((mode) => ({
            paycode: mode.pay_code,
            paytypedesc: mode.pay_typedesc ?? null,
            payIsCredit: Boolean(mode.pay_iscredit),
            payIsCash: Boolean(mode.pay_iscash),
            payAccNo: mode.pay_accno ?? null,
        }));
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load payment modes. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            const detail = error.response.data.detail;
            const message = typeof detail === "string" ? detail : JSON.stringify(detail);
            throw new Error(message);
        }

        throw new Error("Failed to fetch payment modes");
    }
};
